export default __webpack_public_path__ + "static/media/logo.e27ea4d1.svg";